export const MODAL_TITLE = "Capital One Travel Sale";
export const DESTINATION_LIST_HEADING = "Destinations on sale by continent";
export const NO_RESULTS_TEXT =
  "The location you entered does not match a location currently on sale.";
